import { render, staticRenderFns } from "./DatatableMaterial.vue?vue&type=template&id=1616235c&scoped=true"
import script from "./DatatableMaterial.vue?vue&type=script&lang=js"
export * from "./DatatableMaterial.vue?vue&type=script&lang=js"
import style0 from "./DatatableMaterial.vue?vue&type=style&index=0&id=1616235c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616235c",
  null
  
)

export default component.exports